// import "babel-polyfill"
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "antd/dist/antd.css"
import {ConfigProvider} from "antd"
import zhCN from 'antd/lib/locale-provider/zh_CN';
import * as serviceWorker from './serviceWorker';

// document.domain='58.com';
// window.WMDA_SDK_CONFIG = ({
//     api_v: 1,
//     sdk_v: 0.1,
//     mode: 'report',
//     appid: 10104502633911,
//     key: '278e3v2j',
//     project_id: '10104295692471',
//     cookie_domain: document.domain,   //58域下不需要该字段
//     cate_id: '',   //按需填写
//     page_extra: [{   //按需填写
//         key: '',
//         value: ''
//     }],
//     user_extra: [{   //按需填写
//         key: '',
//         value: ''
//     }],
//     channel: '',   //按需填写
//     getUserId: function() {},   //按需填写
//     SPA_HASH: true, //单页应用必选
// });
// (function() {
//     var wmda = document.createElement('script');
//     wmda.type='text/javascript';
//     wmda.async = true;
//     wmda.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'j1.58cdn.com.cn/wmda/js/statistic.js?' + (+new Date());
//     var s = document.getElementsByTagName('script')[0];
//     s.parentNode.insertBefore(wmda, s);
// })();



ReactDOM.render(
    <ConfigProvider locale={zhCN}>
    <App />
    </ConfigProvider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
